module.exports = __webpack_public_path__ + "img/box-right-user.e73f37ae.png";